import React from 'react';
import { motion } from 'framer-motion';
import { IS_SSR } from '../lib/env';

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = '', testid }) => (
  <motion.div
    data-testid={testid}
    className={className}
    initial={IS_SSR ? false : { opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15, margin: '-60px' }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = '' }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={IS_SSR ? false : { y: '112%' }}
      animate={{ y: '0%' }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, className = '' }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.25em] text-flame ${className}`}>{children}</p>
);
